import Head from "next/head";

import ResetPasswordC from "@/components/auth/reset-password";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function ResetPassword() {
  return (
    <>
      <Head>
        <title>{seoData.RESET_PASSWORD.title}</title>
        <SeoMetaData data={seoData.RESET_PASSWORD} />
      </Head>

      <ResetPasswordC />
    </>
  );
}
